import React, { useState } from 'react';
import styled from 'styled-components';
import SaleDetailsPopup from './SaleDetailsPopup';
import BannerText from './BannerText';

const Wrapper = styled.div`
  background: ${props => props.theme.old ? props.theme.colors.french : props.theme.colors.newPromo };
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px;

  .copy {
    color: ${props => props.theme.old ? 'white' : props.theme.colors.charcoal };
    //color: white;
  }

  .sale-page-linkm, .see-details-btn {
     color: ${props => props.theme.old ? 'white' : props.theme.colors.charcoal };
    //color: white;
    text-decoration: underline;

    &:hover {
      color: ${props => props.theme.old ? 'white' : props.theme.colors.charcoal };
      //color: white;
    }
  }
`;

function NavBannerDesktop({ className }) {
  const [open, setOpen] = useState(false);

  const toggle = () => {
    setOpen(!open);
  };
  return (
    <Wrapper className={className ? className : ''}>
      <BannerText onClick={toggle} />
      <SaleDetailsPopup open={open} toggle={toggle} />
    </Wrapper>
  );
}

export default NavBannerDesktop;
